import * as React from "react";
import TextField from "@mui/material/TextField";
import DateAdapter from "@mui/lab/AdapterMoment";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import StaticDatePicker from "@mui/lab/StaticDatePicker";

export default function StaticDatePickerDemo({
  handleDateChange,
  handleAccept,
  dateValue,
}) {
  const [value, setValue] = React.useState(new Date());

  const handleChange = (newValue) => {
    setValue(newValue);
    handleDateChange(newValue);
  };

  return (
    <LocalizationProvider dateAdapter={DateAdapter}>
      <StaticDatePicker
        disableFuture
        disableHighlightToday
        displayStaticWrapperAs="desktop"
        value={dateValue}
        onChange={handleChange}
        renderInput={(params) => (
          <TextField {...params} sx={{ width: "100%" }} />
        )}
      />
    </LocalizationProvider>
  );
}
